import React from 'react';
import { Route, Switch } from 'react-router-dom';
import DeliverabilityHubPage from '@/pages/deliverability-hub';

export default function Routes() {
  return (
    <Switch>
      <Route exact path="/" component={DeliverabilityHubPage} />
    </Switch>
  );
}
